import { render, staticRenderFns } from "./EmailAddressManager.vue?vue&type=template&id=e5022b6a&scoped=true&"
import script from "./EmailAddressManager.vue?vue&type=script&lang=js&"
export * from "./EmailAddressManager.vue?vue&type=script&lang=js&"
import style0 from "./EmailAddressManager.vue?vue&type=style&index=0&id=e5022b6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5022b6a",
  null
  
)

export default component.exports